import React, {useState, useEffect} from 'react';
import './modalMulti.css';
import { modalmultiData } from '../../json/modalmulti';

const Modal = ({hijoAPadre}) => {
  const data = {
    url1: 'https://s-seguridad.hidalgo.gob.mx/assets/pdf/procesal202608.pdf',
    url2: 'https://s-seguridad.hidalgo.gob.mx/assets/pdf/penitenciario202608.pdf'
   
  };

  const irConvocatoria1 = () => {
    window.open(data.url1, '_blank');
  }
  const irConvocatoria2 = () => {
    window.open(data.url2, '_blank');
  }

  const[arreglo, setArreglo]=useState([]);

  function cerrar(){
    hijoAPadre(false);
}

useEffect(()=>{
  if(modalmultiData){
    setArreglo(modalmultiData);
  }
 
},[]);

  return (
      <div> 
       <div className='modalContainer'>
                <div  className='squareModal'>
                    <div className='derecha'>
                        <a href='#'><h1 className='cerrar' onClick={cerrar}>X</h1></a>
                    </div>
                    <div>
                        <h1 className='modalTitulo'>{arreglo.titulo}</h1>
                    </div>
                    <br/>
                    <div className='row fila-contenedor'>
                    <div className='col-lg-6 col-sm-12'>
                        <a href={arreglo.link1} target='_blank'>
                        <img width="100%" src={arreglo.imagen1}></img>
                        </a>
                        <div
                          class="button_slide_right slide_right_2"
                          onClick={irConvocatoria1}
                        >
                          Ir a la convocatoria
                    </div>
                    </div>

                    <div className='col-lg-6 col-sm-12'>
                        <a href={arreglo.link2} target='_blank'>
                        <img width="100%" src={arreglo.imagen2}></img>
                        </a>
                        <div
                          class="button_slide_right slide_right_2"
                          onClick={irConvocatoria2}
                        >
                          Ir a la convocatoria
                        </div>
                    </div>

                    </div>
                    
                   
                    

                </div>
                
        </div> 
       
      </div>
  )
}

export default Modal